<template>
  <image-list :list="list" />
</template>

<script>
import ImageList from "@/components/ImageList.vue";

export default {
  name: "tegninger",
  components: {
    ImageList
  },
  data() {
    return {
      list: [
        {
          id: 1,
          type: "LeftRightText2",
          leftImage: "/images/tegninger/1/left.jpg",
          leftImageHeight: 450,
          leftText: "SKITSEBØGER",
          rightText: ""
        },
        {
          id: 2,
          type: "Center",
          centerImage: "/images/tegninger/2/center.jpg",
          leftText: "ISIS TEMPEL PHILAE ASSWAN ÆGYPTEN",
          rightText: ""
        },
        {
          id: 3,
          type: "LeftRight",
          leftImage: "/images/tegninger/3/left.jpg",
          leftImageHeight: 330,
          rightImage: "/images/tegninger/3/right.jpg",
          rightImageHeight: 330,
          leftText: "TRAJANS KIOSK ALCHETRON PHILAE ASSWAN &nbsp;&nbsp;&nbsp; EDFU NILEN",
          rightText: ""
        },
        {
          id: 4,
          type: "LeftRight",
          leftImage: "/images/tegninger/4/left.jpg",
          leftImageHeight: 330,
          rightImage: "/images/tegninger/4/right.jpg",
          rightImageHeight: 330,
          leftText: "GIZA CAIRO &nbsp;&nbsp;&nbsp; HATSHEPSUT TEMPEL LUXOR",
          rightText: ""
        },
        {
          id: 5,
          type: "Center",
          centerImage: "/images/tegninger/5/center.jpg",
          leftText: "BEL-SHAMIN TEMPLET PALMYRA SYRIEN",
          rightText: ""
        },
        {
          id: 6,
          type: "LeftRight",
          leftImage: "/images/tegninger/6/left.jpg",
          leftImageHeight: 330,
          rightImage: "/images/tegninger/6/right.jpg",
          rightImageHeight: 330,
          leftText: "UMAYYAD MOSKEÉN DAMASKUS &nbsp;&nbsp;&nbsp; VANDMANDEN DAMASKUS",
          rightText: ""
        },
        {
          id: 7,
          type: "LeftRight",
          leftImage: "/images/tegninger/7/left.jpg",
          leftImageHeight: 330,
          rightImage: "/images/tegninger/7/right.jpg",
          rightImageHeight: 330,
          leftText: "CANOPO VILLA ADRIANO TIVOLI &nbsp;&nbsp;&nbsp; CAPITOLIUM OSTIA ITALIEN",
          rightText: ""
        },
        {
          id: 8,
          type: "Center",
          centerImage: "/images/tegninger/8/center.jpg",
          leftText: "BAR SAN CALISTO TRASTEVERA ROM",
          rightText: ""
        },
        {
          id: 9,
          type: "LeftRight",
          leftImage: "/images/tegninger/9/left.jpg",
          leftImageHeight: 400,
          rightImage: "/images/tegninger/9/right.jpg",
          rightImageHeight: 400,
          leftText: "PIAZZA DEL POPOLO &nbsp;&nbsp;&nbsp; SCALINA DELLA TRINTA DEI MONTI ROM",
          rightText: ""
        },
        {
          id: 10,
          type: "Center",
          centerImage: "/images/tegninger/10/center.jpg",
          leftText: "VILLA ADRIANA TEATRO MARITTIMO",
          rightText: ""
        },
        {
          id: 11,
          type: "Center",
          centerImage: "/images/tegninger/11/center.jpg",
          leftText: "BATTISTERO DI SAN GIOVANNI FIRENZE",
          rightText: ""
        },
        {
          id: 12,
          type: "LeftRight",
          leftImage: "/images/tegninger/12/left.jpg",
          leftImageHeight: 320,
          rightImage: "/images/tegninger/12/right.jpg",
          rightImageHeight: 320,
          leftText: "BASILICA DI SANTA MARIA DELLA SALUTE VENEZIA",
          rightText: ""
        },
        {
          id: 13,
          type: "LeftRight",
          leftImage: "/images/tegninger/13/left.jpg",
          leftImageHeight: 320,
          rightImage: "/images/tegninger/13/right.jpg",
          rightImageHeight: 320,
          leftText: "PONTE DI RIALTO &nbsp;&nbsp;&nbsp; SCUOLA GRANDE DI SAN MARCO VENEZIA",
          rightText: ""
        },
        {
          id: 14,
          type: "LeftRight",
          leftImage: "/images/tegninger/14/left.jpg",
          leftImageHeight: 320,
          rightImage: "/images/tegninger/14/right.jpg",
          rightImageHeight: 320,
          leftText: "QUERINI STAMPALIA &nbsp;&nbsp;&nbsp; SANTA MARIA FORMOSA VENEZIA",
          rightText: ""
        },
        {
          id: 15,
          type: "LeftRight",
          leftImage: "/images/tegninger/15/left.jpg",
          leftImageHeight: 400,
          rightImage: "/images/tegninger/15/right.jpg",
          rightImageHeight: 400,
          leftText: "SANTA MARIA DEI FRARI &nbsp;&nbsp;&nbsp; SAN GIACOMO DELL ORIO VENEZIA",
          rightText: ""
        },
        {
          id: 16,
          type: "LeftRight",
          leftImage: "/images/tegninger/16/left.jpg",
          leftImageHeight: 400,
          rightImage: "/images/tegninger/16/right.jpg",
          rightImageHeight: 400,
          leftText: "RIO DEI CARMINI &nbsp;&nbsp;&nbsp; RIO DE SAN TROVASO VENEZIA",
          rightText: ""
        },
        {
          id: 17,
          type: "LeftRight",
          leftImage: "/images/tegninger/17/left.jpg",
          leftImageHeight: 400,
          rightImage: "/images/tegninger/17/right.jpg",
          rightImageHeight: 400,
          leftText: "SANTA MARIA MADDALENA PENITENTE &nbsp;&nbsp;&nbsp; SAN SALVATORE DE BIRECTO ATRANI",
          rightText: ""
        },
        {
          id: 18,
          type: "LeftRight",
          leftImage: "/images/tegninger/18/left.jpg",
          leftImageHeight: 320,
          rightImage: "/images/tegninger/18/right.jpg",
          rightImageHeight: 320,
          leftText: "PLAZA DE TOROS SEVILLA SPANIEN",
          rightText: ""
        },
        {
          id: 19,
          type: "Center",
          centerImage: "/images/tegninger/19/center.jpg",
          leftText: "LA MEZQUITA CORDOBA SPAIN",
          rightText: ""
        },
        {
          id: 20,
          type: "Center",
          centerImage: "/images/tegninger/20/center.jpg",
          leftText: "FLAMINGO CORDOBA",
          rightText: ""
        },
        {
          id: 21,
          type: "Center",
          centerImage: "/images/tegninger/21/center.jpg",
          leftText: "BEDFORD SQUARE GARDEN LONDON",
          rightText: ""
        },
        {
          id: 22,
          type: "Center",
          centerImage: "/images/tegninger/22/center.jpg",
          leftText: "CHARLESTON SOUTH CAROLINA USA",
          rightText: ""
        },
        {
          id: 23,
          type: "Center",
          centerImage: "/images/tegninger/23/center.jpg",
          leftText: "MONTICELLO VIRGINIA USA",
          rightText: ""
        },
        {
          id: 24,
          type: "Center",
          centerImage: "/images/tegninger/24/center.jpg",
          leftText: "THE LAWN UNIVERSITY OF VIRGINIA CHARLOTTESVILLE USA",
          rightText: ""
        },
      ]
    };
  }
};
</script>
